import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class WoolTraceabilityAnimation extends React.PureComponent<WoolTraceabilityAnimation.Props, WoolTraceabilityAnimation.State> {
  public static sectionId = 'wooltra';
  private aniLengthMobile = 2037;

  public constructor(props) {
    super(props)

    this.state = {
      pathMobile: null,
      pathDesktop: null,
      mobileRawProgress: 0,
      desktopRawProgress: 0,
    }
  }

  intervalId = setInterval(() => {
    if (this.state.desktopRawProgress === 10) {
      clearInterval(this.intervalId)
    } else {
      const desktopRawProgress = this.state.desktopRawProgress + 1
      this.setState({
        desktopRawProgress,
      })
    }
  }, 1000);

  public componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)

    const pathMobile = document.querySelector('.thread.mobile .path')

    if (pathMobile) {
      // @ts-ignore
      pathMobile.style.strokeDasharray = pathMobile.style.strokeDashoffset
    }

    this.setState({
      pathMobile
    })
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  convertProgress = (progress, start, end) => Math.min(Math.max((progress - start) / (end - start), 0), 1)

  handleScroll = () => {

    // @ts-ignore
    const { offsetTop } = document.querySelector('.dynamic-wool-traceability-animation')
    const mobileRect = this.state.pathMobile.getBoundingClientRect()
    
    const windowHeight = window.innerHeight
    const { top, height } = mobileRect
    
    const offset = windowHeight * 0.18

    const startPoint = (offsetTop - offset)
    const screenPos = (startPoint - windowHeight) - top
    const endPoint = (height + offset)

    const mobileRawProgress = screenPos / endPoint
    
    const mobileProgress = Math.max(mobileRawProgress, 0)
    
    if ( mobileProgress > this.state.mobileRawProgress) {
      const dashProgress = Math.min(mobileProgress, 1)        
      this.state.pathMobile.style.strokeDashoffset = this.aniLengthMobile * (1 - dashProgress)

      this.setState({ mobileRawProgress })
    }
  }

  public render(): JSX.Element {
    const settings = this?.props?.section?.settings

    // the below code is used to make the mobile icons stay visibile when a user scrolls down
    if (this.state.mobileRawProgress >= 1.1) {
      const items = document.querySelectorAll('.wool-traceability-animation-item')

      items.forEach(item => {
        const divs = item.querySelectorAll('div')
        for (let i = 0; i < divs.length; i++) {
          const div = divs[i]
          div.classList.add('dynamic-wool-traceability-animation-mobile__scale')
        }
      })
    }
    return (
      <section className={'dynamic-wool-traceability-animation relative overflow-hidden w-full flex items-center justify-center'}>
        <div style={{ backgroundColor: '#D1C9B9', width: '1450px', maxWidth: '100%' }}>
          <div className={'px-2 lg:px-4'}>
            <div className={'mobile-wta-container relative md:hidden'}>
              <div style={{ paddingTop: '20%', paddingBottom: '300px' }}>
                <div className={'relative'}>
                  <svg className={'thread mobile'} viewBox="0 0 327.45 927.86"><path className={'path'} fill="transparent" stroke="#000" d="M131.74,1.93c27-3.81,67.75-1.43,94.72,2.42,66.6,3.75,100.78,41.82,100.87,116A76.81,76.81,0,0,1,300,182.92l-76.63,21.45A509.4,509.4,0,0,0,130,198.74c-50.76-5-91.36,51-121.12,172C-9.61,395.89,2.7,450.26,28.15,467l107.13,10.57c21.58,6.71,44.85,2.55,67.05-1.65,74-10,120.66,23.64,122.35,128.94,2.73,30.2-2.21,60.82-26.77,81.11L212,715a241.36,241.36,0,0,1-73.39,3.34C67.5,714.87,23.28,736,15.27,790.22,9,813.13,5.55,837.12,8.53,860.68s12.8,46.73,30.05,63.05l97.69,1.9c50.27,8.08,101.67-8.8,152.31-3.5" /></svg>
                  <WoolTraceabilityAnimationItem mobile settings={settings} suffix={'one'} progress={this.state.mobileRawProgress} progressStart={0} top={'-5%'} left={'-3%'} width={'155px'} /> {/* 1 */}
                  <WoolTraceabilityAnimationItem mobile settings={settings} suffix={'two'} progress={this.state.mobileRawProgress} progressStart={0.1} top={'-8%'} left={'57%'} width={'150px'} /> {/* 2 */}
                  <WoolTraceabilityAnimationItem mobile settings={settings} suffix={'three'} progress={this.state.mobileRawProgress} progressStart={0.2} top={'17%'} left={'50%'} width={'180px'} /> {/* 3 */}
                  <WoolTraceabilityAnimationItem mobile settings={settings} suffix={'four'} progress={this.state.mobileRawProgress} progressStart={0.35} top={'22%'} left={'-4%'} width={'135px'} /> {/* 4 */}
                  <WoolTraceabilityAnimationItem mobile settings={settings} suffix={'five'} progress={this.state.mobileRawProgress} progressStart={0.45} top={'47%'} left={'-5%'} width={'160px'} /> {/* 5 */}
                  <WoolTraceabilityAnimationItem mobile settings={settings} suffix={'six'} progress={this.state.mobileRawProgress} progressStart={0.55} top={'45%'} left={'48%'} width={'190px'} /> {/* 6 */}
                  <WoolTraceabilityAnimationItem mobile settings={settings} suffix={'seven'} progress={this.state.mobileRawProgress} progressStart={0.7} top={'72%'} left={'40%'} width={'190px'} /> {/* 7 */}
                  <WoolTraceabilityAnimationItem mobile settings={settings} suffix={'eight'} progress={this.state.mobileRawProgress} progressStart={0.8} top={'79%'} left={'-6%'} width={'137px'} /> {/* 8 */}
                  <WoolTraceabilityAnimationItem mobile settings={settings} suffix={'nine'} progress={this.state.mobileRawProgress} progressStart={0.9} top={'99%'} left={'44%'} width={'220px'} /> {/* 9 */}
                </div>
              </div>
              <div className={'text-center wool-font'} style={{ lineHeight: '16px', position: 'absolute', left: 0, right: 0, bottom: '20px', opacity: this.convertProgress(this.state.mobileRawProgress, 0.95, 1) }}>{settings?.['footer']}</div>
            </div>
            <div className={'wta-container relative hidden md:block lg:block'}>
              <div style={{ paddingTop: '19%', paddingBottom: '300px' }}>
                <div className={'relative'}>
                  <svg className={'thread desktop'} viewBox="0 0 1051.18 559.92"><path className={'path'} fill="transparent" stroke="#000" d="M284.15,5.39c42.29-4.65,106.24-1.74,148.52,3l166.19,4.47c28.83,5.05,57.59,5.62,86.85,4.93s55.62-6.88,84.12-12L941.18,0c22.92.22,47.16,1.74,66.17,14.93,12.89,8.93,22.21,22.61,28,37.44,8.63,21.95,9.7,47.84-.94,68.84-11.7,23.08-37.53,37.71-62.73,35.52-5.26-.46-11.54-2.62-12.5-8-1.3-7.2,7.76-11.17,14.79-12.25a60.17,60.17,0,0,1,33.31,4.06c28.58,12.65,49.29,42.81,41.77,75.31-4.65,20.11-18.59,38.83-34.67,50.91a88,88,0,0,1-36.72,16.4l-247.15-2.52c-27,4.57-54.62.48-81.29-4.53-27.29-5.12-54.72-9.27-82.13-13.73l-122.69,2.33c-40.49,1.5-79.75,13.88-119.46,20.82-25.69,4.48-51.36,6.59-77.28,2.7L78.48,295.68C44.76,316.05,18.32,354.35,6.06,397.19c-18.27,63.86,4.88,159.89,67.92,162a65.71,65.71,0,0,0,8.36-.26l178.5,0a542.41,542.41,0,0,0,177.93-23.47l152.5-1a1133.32,1133.32,0,0,1,122.34,10c16.94,2.31,33.72,5.53,50.53,8.49" /></svg>
                  <WoolTraceabilityAnimationItem settings={settings} suffix={'one'} progress={3.6} progressStart={0} top={'-135px'} left={'9%'} />
                  <WoolTraceabilityAnimationItem settings={settings} suffix={'two'} progress={this.state.desktopRawProgress >= 1 ? 3.6 : 0} progressStart={0.1} top={'-181px'} left={'40%'} />
                  <WoolTraceabilityAnimationItem settings={settings} suffix={'three'} progress={this.state.desktopRawProgress >= 2 ? 3.6 : 0} progressStart={0.2} top={'-133px'} left={'72%'} />
                  <WoolTraceabilityAnimationItem settings={settings} suffix={'four'} progress={this.state.desktopRawProgress >= 4 ? 3.6 : 0} progressStart={0.35} top={'29%'} left={'65%'} width={'280px'} />
                  <WoolTraceabilityAnimationItem settings={settings} suffix={'five'} progress={this.state.desktopRawProgress >= 5 ? 3.6 : 0} progressStart={0.45} top={'30%'} left={'36%'} />
                  <WoolTraceabilityAnimationItem settings={settings} suffix={'six'} progress={this.state.desktopRawProgress >= 6 ? 3.6 : 0} progressStart={0.55} top={'34%'} left={'6%'} />
                  <WoolTraceabilityAnimationItem settings={settings} suffix={'seven'} progress={this.state.desktopRawProgress >= 8 ? 3.6 : 0} progressStart={0.7} top={'84%'} left={'7%'} />
                  <WoolTraceabilityAnimationItem settings={settings} suffix={'eight'} progress={this.state.desktopRawProgress >= 9 ? 3.6 : 0} progressStart={0.8} top={'77%'} left={'40%'} />
                  <WoolTraceabilityAnimationItem settings={settings} suffix={'nine'} progress={this.state.desktopRawProgress >= 10 ? 3.6 : 0} progressStart={0.9} top={'76%'} left={'72%'} />
                </div>
              </div>
              <div className={'text-center wool-font'} style={{ lineHeight: '16px', position: 'absolute', left: 0, right: 0, bottom: '20px', opacity: this.convertProgress(this.state.desktopRawProgress, 0.95, 1) }}>{settings?.['footer']}</div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export namespace WoolTraceabilityAnimation {
  export type Options = ShopifyNext.Section<{
  }>;
  export interface Props extends GlobalProps {
    section: WoolTraceabilityAnimation.Options;
  }
  export interface State {
    pathMobile: any
    pathDesktop: any
    mobileRawProgress: number
    desktopRawProgress: number
  }
}

export class WoolTraceabilityAnimationItem extends React.PureComponent<WoolTraceabilityAnimationItem.Props, WoolTraceabilityAnimationItem.State> {
  public constructor(props) {
    super(props)

    this.state = {
    }
  }

  convertProgress = (progress, start, end) => {
    const firstVal = progress - start
    const secondVal = end - start
    const thirdVal = firstVal / secondVal
    const fourthVal = Math.max(thirdVal, 0)
    const fifthVal = Math.min(fourthVal, 1)    
    
    return fifthVal
  }

  public render(): JSX.Element {
    const { settings, progress, progressStart, suffix, top, left, width, mobile } = this.props
    const resolvedImageProgress = this.convertProgress(progress, progressStart, progressStart + 0.2)
    const resolvedHeadingProgress = this.convertProgress(progress, progressStart, progressStart + 0.1)
    const resolvedBodyProgress = this.convertProgress(progress, progressStart, progressStart + 0.2)
  
        
    return (
      <div className={'wool-traceability-animation-item text-center'} style={{ backgroundColor: '#D1C9B9', padding: 12, position: 'absolute', top, left, width: width || 260 }}>
        <div className={'w-5 sm-tablet:w-7 md:w-7 lg:w-10'} style={{ margin: '0 auto', opacity: resolvedImageProgress, transform: `scale(${resolvedImageProgress})` }}>
          <Snippets.Image src={settings?.[`image${suffix}`]} alt={''} ratio={'natural'} preventLazy />
        </div>
        <div className={'font-mono'} style={{ fontSize: `${mobile ? '20px' : '30px'}`, lineHeight: `${mobile ? '23px' : '28px'}`, margin: '12px 0', opacity: resolvedHeadingProgress }}>{settings?.[`heading${suffix}`]}</div>
        <div className="wool-font" style={{ lineHeight: '16px', opacity: resolvedBodyProgress }}>{settings?.[`body${suffix}`]}</div>
      </div>
    )
  }
}

export namespace WoolTraceabilityAnimationItem {
  export interface Props {
    settings: any;
    progress: number;
    progressStart: number;
    suffix: string;
    top: any;
    left: any;
    width?: any;
    mobile?: boolean;
    none?: boolean;
  }
  export interface State {
  }
}
